<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img
          :class="!marketList.length ? 'topImg' : 'secImg'"
          :src="currentModule.url"
          :alt="currentModule.title"
        />
      </div>
      <carbon-market
        :marketList="marketList"
        @backHome="backHome"
        v-if="marketList.length"
      />
      <div v-else class="CarbonFootprint">
        <div class="cardBox" v-for="(item, index) in CarbonFootprint">
          <div class="CarbonFootprint_top">
            <img
              :class="'CarbonFootprint_top_img' + index"
              :src="item.img"
              alt=""
            />
          </div>
          <div class="CarbonFootprint_btn">
            <div class="CarbonFootprint_btn_title">{{ item.title }}</div>
            <div class="CarbonFootprint_btn_content">{{ item.content }}</div>
          </div>
          <div
            @click="choseCrad(item)"
            class="views"
            v-if="item.title == '碳交易数据'"
          >
            <div class="views_box">
              <span>点击进入</span>
              <img :src="enterUrl" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import carbonMarket from '@/views/carbonFootprint/components/carbonMarket.vue';
import { getCarbonFootprint } from '@/API/goverment/goverment';
import { scrollTop } from '@/util/scrollTop';
export default {
  components: {
    bottomUrl,
    carbonMarket,
  },
  data() {
    return {
      marketList: [],
      // 8个模块的配置数据
      currentModule: {
        title: '碳足迹管理',
        url: require('@/assets/recycling/index/bg5.png'),
      },
      enterUrl: require('@/assets/recycling/index/enter.png'),
      CarbonFootprint: [
        {
          img: require('@/assets/recycling/index/CarbonFootprint1.png'),
          title: '什么是碳足迹',
          content:
            '碳足迹是衡量个人、企业、组织机构等的活动所产生的二氧化碳排放量的指标。"碳"是指石油、煤炭、木材等由碳元素构成的自然资源。"碳"的消耗用量越多，产生的二氧化碳也越多，碳足迹就越大，反之，碳足迹就越小。',
        },
        {
          img: require('@/assets/recycling/index/CarbonFootprint3.png'),
          title: '碳交易数据',
          content:
            '增强环保意识，使用节能灯泡替换白炽灯，使用只含有少量或不含氟利昂的绿色环保冰箱，购买新能源汽车，选择公共交通出行，购买本地食品，植树造林。',
        },
      ],
      carbonList: [],
    };
  },
  mounted() {},
  methods: {
    choseCrad(item) {
      if (item.title == '碳交易数据') {
        this.currentModule.url = require('@/assets/recycling/index/bg5_1.png');
        this.marketList = [];
        getCarbonFootprint().then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length) {
              this.marketList = res.data;
            } else {
              this.$message.error('数据查询失败');
            }
          }
        });
      }
    },
    backHome() {
      this.marketList = [];
      this.currentModule.url = require('@/assets/recycling/index/bg5.png');
    },
  },
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
  padding-bottom: 32px; /* 为底部组件预留空间 */
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  margin: 0 auto 10px;
  display: block;
}
.secImg {
  width: 100%;
}
.topImg {
  object-fit: cover;
  width: 100%;
  height: 730px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.CarbonFootprint {
  width: 1400px;
  height: 360px;
  margin: 34px auto 0 auto;
  display: flex;
  justify-content: space-between;
  .cardBox {
    background: rgba(235, 238, 240, 1);
    width: 49%;
    height: inherit;
    padding: 25px;
    position: relative;
    .CarbonFootprint_top {
      min-height: 61px;
      .CarbonFootprint_top_img0 {
        width: 100px;
        height: 100px;
      }
      .CarbonFootprint_top_img1 {
        width: 100px;
        height: 100px;
      }
      //.CarbonFootprint_top_img2{
      //  width: 63px;
      //  height: 45px;
      //}
    }
    .CarbonFootprint_btn {
      .CarbonFootprint_btn_title {
        font-size: 20px;
        font-weight: 500;
        line-height: 28.96px;
        color: rgba(0, 0, 0, 1);
        margin: 15px 0;
      }
      .CarbonFootprint_btn_content {
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 23.17px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
.views {
  position: absolute;
  left: 32px;
  bottom: 36px;
  cursor: pointer;
  .views_box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 0 10px;
    min-width: 136px;
    min-height: 36px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #15ad61;
    color: #15ad61;
  }
}
.views:hover {
  scale: 1.01;
  transition: scale 0.2s ease;
}


@media screen and (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: auto;
    padding: 0 16px;
    background-size: 90% auto; /* 移动端适当缩小 */
  
    .CarbonFootprint {
      flex-direction: column;
      margin: 8px 0 20px;
      width: 100%;
      height: auto;
      .cardBox {
        width: 100%;
        height: auto;
        margin: 8px 0;
        .CarbonFootprint_top {
            width: 70px;
            margin-top: 10px;
            .CarbonFootprint_top_img0,.CarbonFootprint_top_img1 {
              width: 50px;
              height: auto;
              margin: 0 10px;
            }
        }
        .CarbonFootprint_btn{
          padding: 8px;
          .CarbonFootprint_btn_title {
            font-size: 14px;
            line-height: normal;
          }
          .CarbonFootprint_btn_content {
            font-size: 12px;
            line-height: normal;
            margin: 10px 0;
          }
        }
        .views {
          position: relative;
          bottom: 0;
          left: 0;
          margin: 10px;
          .views_box {
            height: 35px;
            justify-content: center;
            border-radius: 5px;
            span {
              font-size: 14px;
            }
          }
        }
      }
    }
    
  }

}

</style>
